import { ModosOp} from "../../isp.pantalla.principal/reductores/Constantes";
import { TipoItem, Moneda, Udm } from "./Constantes";

//Si no hay input para el Dialogo de Cliente a Facturar
const getEstadoInicial = () => {
    return {
        domain: {
            screen:{
                idItem: "-------",
                fechaReg: "--/--/--",
                estado: "-------",

                tipoItem: TipoItem.PlanInternet,
                nombre: "",
                descripcion: "",
                precio: "",
                moneda: Moneda.Soles,
                udm: Udm.Mensual,
                combos:{
                    udms:[Udm.Mensual],
                    tiposItem:[TipoItem.PlanInternet,TipoItem.ServiciosGen, TipoItem.Articulo]
                }
            },
            cargado: {}, //Data de una entidad cargada en el dialogo desde la Base de Datos
            update: {}, //Solo tiene data temporal del dominio va a modificar una entidad
            nroUpdates: 0,
        },
        error: {
            nomBlanc: false,
            nomMF: false,
            descripMF: false,
            precioBlanc: false,
            precioMF: false,
            /* rsocialBlanc: false,
            rsocialMF: false,
            rucBlanc: false,
            rucMF: false,
            telcel1Blanc: false,
            telcel1MF: false,
            telcel2MF: false,
            telfijoMF: false,
            emailMF: false,
            sitioWebMF: false, */
        },
        flag: {
            modoOperacion: ModosOp.CREAR,
            procesandoComando: false,
            modal: false,
            cargandoEntidad: false,
            sensorForceUpdate:false
            // iniciando: true
            // sensorDeAccionGuardar: false,
            // sensorDeAccionActualizar: false,
        },
    };
};

export default getEstadoInicial;
